import {
  CANNOT_CONTAIN_DICTIONARY_WORDS,
  CANNOT_CONTAIN_OLD_PASSWORDS,
  PASSWORD_DICTIONARY_ERROR_MESSAGE,
  PASSWORD_PREVIOUS_24_PASSWORDS_ERROR_MESSAGE,
  PASSWORD_UNSECURE_ERROR_MESSAGE,
  UNSECURE_PASSWORD,
  VALID_PASSWORD,
} from "../../../Constants/AccountSetupConstants";
import {
  API_ACTION_VALIDATE,
  FORGOT_PASSWORD,
  LOGIN_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  LOGIN_INFORMATION_ROUTE,
} from "../../../Constants/CommonConstants";
import {
  THUNK_POST_NEW_PASSWORD,
  THUNK_POST_NEW_PASSWORD_MY_PROFILE,
  THUNK_POST_RESET_FORGOT_PASSWORD,
  THUNK_POST_RESET_PASSWORD,
  THUNK_PUT_RESET_MY_PROFILE_PASSWORD,
} from "../../../Constants/SliceAndThunkConstants";
import {
  clearLoginApiResponse,
  postNewPassword,
} from "../../../Features/LoginSlice";
import {
  clearMyProfileApiResponse,
  postNewPasswordMyProfile,
} from "../../../Features/MyProfileSlice";
import { fetchResponseCodeAndDescription } from "../../../Services/CommonServices";

const newPasswordSuccessStatus = (passwordApiResponse) => {
  const passedValidations = [];
  if (
    passwordApiResponse === VALID_PASSWORD ||
    passwordApiResponse === UNSECURE_PASSWORD
  ) {
    passedValidations.push(PASSWORD_DICTIONARY_ERROR_MESSAGE);
    passedValidations.push(PASSWORD_PREVIOUS_24_PASSWORDS_ERROR_MESSAGE);
  } else if (passwordApiResponse === CANNOT_CONTAIN_OLD_PASSWORDS) {
    passedValidations.push(PASSWORD_DICTIONARY_ERROR_MESSAGE);
  }
  return passedValidations;
};

const newPasswordErrorStatus = (passwordApiResponse) => {
  if (passwordApiResponse === CANNOT_CONTAIN_DICTIONARY_WORDS) {
    return PASSWORD_DICTIONARY_ERROR_MESSAGE;
  } else if (passwordApiResponse === CANNOT_CONTAIN_OLD_PASSWORDS) {
    return PASSWORD_PREVIOUS_24_PASSWORDS_ERROR_MESSAGE;
  } else if (passwordApiResponse === UNSECURE_PASSWORD) {
    return PASSWORD_UNSECURE_ERROR_MESSAGE;
  }
  return null;
};

export const validateNewPasswordResponse = async (
  value,
  dispatch,
  previousScreen
) => {
  let response = {};

  if (previousScreen === FORGOT_PASSWORD || previousScreen === LOGIN_ROUTE) {
    response = await dispatch(
      postNewPassword({
        data: {
          password: value,
        },
        apiAction: API_ACTION_VALIDATE,
      })
    );
    dispatch(clearLoginApiResponse(THUNK_POST_NEW_PASSWORD));
  } else {
    response = await dispatch(
      postNewPasswordMyProfile({
        data: {
          password: value,
        },
        apiAction: API_ACTION_VALIDATE,
      })
    );
    dispatch(clearMyProfileApiResponse(THUNK_POST_NEW_PASSWORD_MY_PROFILE));
  }

  const { description } = fetchResponseCodeAndDescription(response);
  const errorResponse = newPasswordErrorStatus(description);
  const successResponse = newPasswordSuccessStatus(description);

  return { errorResponse, successResponse };
};

export const getRecentDispatchedThunkName = (previousScreen) => {
  switch (previousScreen) {
    case FORGOT_PASSWORD_ROUTE:
      return THUNK_POST_RESET_FORGOT_PASSWORD;
    case LOGIN_INFORMATION_ROUTE:
      return THUNK_PUT_RESET_MY_PROFILE_PASSWORD;
    case LOGIN_ROUTE:
      return THUNK_POST_RESET_PASSWORD;
    default:
      return null;
  }
};
